import { useEffect, type ReactNode } from 'react'
import { useRouter } from 'next/router'

import { Spinner } from '@wartek-id/spinner'
import { useToast } from '@wartek-id/toast'

import usePeriodContext from 'app/KinerjaShared/hooks/usePeriodContext'
import { isDateStarted } from 'app/KinerjaShared/utils/pelaksanaan'
import {
  PENGELOLAAN_KINERJA_BASE_PATH,
  PENGELOLAAN_KINERJA_GURU_PATH,
  PENGELOLAAN_KINERJA_KS_PENILAI_PATH,
} from 'app/KinerjaShared/constants/path'

type PageGuardPelaksanaanDateProps = {
  children?: ReactNode
}

export function PageGuardPelaksanaanDate({
  children,
}: PageGuardPelaksanaanDateProps) {
  const toast = useToast()
  const { period, periods } = usePeriodContext()
  const router = useRouter()

  const isPelaksanaanStarted = isDateStarted(period.periodeKinerja)
  const isResolved = Array.isArray(periods) && periods.length > 0

  useEffect(() => {
    if (isResolved && !isPelaksanaanStarted && router.isReady) {
      let redirectPath = PENGELOLAAN_KINERJA_BASE_PATH
      const currentPath = router.asPath

      if (currentPath.includes(PENGELOLAAN_KINERJA_KS_PENILAI_PATH)) {
        redirectPath = PENGELOLAAN_KINERJA_KS_PENILAI_PATH
      } else if (currentPath.includes(PENGELOLAAN_KINERJA_GURU_PATH)) {
        redirectPath = PENGELOLAAN_KINERJA_GURU_PATH
      }

      router.replace(redirectPath)
      toast({
        message:
          'Tahap Pelaksanaan dan Penilaian belum dimulai untuk periode tersebut.',
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isResolved, isPelaksanaanStarted, router.isReady])

  if (!isResolved || !isPelaksanaanStarted) {
    return (
      <div className="bg-gray-10 min-h-full flex pt-20 justify-center">
        <Spinner />
      </div>
    )
  }

  return <>{children}</>
}
